import React from 'react'
import pageStyle from './page.module.css'
import { useNavigate } from 'react-router-dom'

const PageNotFound = () => {

    const nav = useNavigate()
    return (
        <div className={pageStyle.mainContainer}>
            <div className={pageStyle.leftSideContent}>
                <div className={pageStyle.error404}>
                    Error 404
                </div>
                <div className={pageStyle.oopPageNotFound}>
                    Oops! page not found
                </div>
                <p className={pageStyle.description}>
                    Something went wrong. It’s look that your requested could not be found. It's look like the link is broken or the page is removed.
                </p>
                <div className={pageStyle.goBackButton} onClick={() => nav('/courses/Courses')}>
                    <p>Go Back</p>
                </div>
            </div>
            <div className={pageStyle.rightSideContent} >
                <img src='/404Page.png' alt='404 Page Error'width="100%"/>
            </div>
        </div>
    )
}

export default PageNotFound;